module.exports = __webpack_public_path__ + "img/fa-solid-globe-europe.6128f0df.svg";